import {Avatar, Box, Drawer, Grid, IconButton, Stack, Tab, Tabs, Typography} from "@mui/material";
import {DataGrid} from "@mui/x-data-grid";
import moment from "moment";
import {useEffect, useState} from "react";
import {
  BALANCE_RECORD_TYPE_MAP,
  IMG_BASE_URL,
  PAYMENT_STATUS,
  PAY_METHOD_MAP,
  POINT_CATEGORY_MAP,
  POINT_RECORD_TYPE_MAP
} from "src/config/constants";
import {asyncRequest} from "src/services/network";
import UserInfo from "./UserInfo";
import SectionHeader from "../section-header/SectionHeader";
import {useSelector} from "react-redux";
import {getAreas} from "src/services/request";
import MerchantInfo from "./MerchantInfo";
import {CloseOutlined} from "@mui/icons-material";
import Decimal from "decimal.js"

const orderColumns = [
  // { field: 'id', headerName: 'ID', width: 90 },
  {
    field: "orderSN",
    headerName: "订单编号",
    width: 190,
    // editable: true,
  },
  {
    field: "totalPrice",
    headerName: "订单金额",
    align: "center",
    type: "number",
    width: 90,
    valueGetter: (value, row) => `￥${value}`,
  },
  {
    field: "rangli",
    headerName: "让利金额(比例)",
    align: "center",
    width: 120,
    valueGetter: (value, row) => `￥${row.rangli}(${new Decimal(value).div(row.totalPrice).mul(100).toFixed(0)}%)`,
  },
  {
    field: "detail",
    headerName: "商家应收",
    type: "number",
    align: "center",
    width: 90,
    valueGetter: (value, row) => `￥${new Decimal(row.totalPrice).sub(row.rangli).toNumber()}`,
  },
  {
    field: "sid",
    headerName: "支付信息(金额 | 消费券 | 积分)",
    type: "number",
    align: "center",
    width: 220,
    valueGetter: (value, row) => `￥${row.payPrice} | ${row.deductionXfqV2} | ${row.deductionPointsV2}`,
  },
  {
    field: "payMethod",
    headerName: "支付方式",
    // description: 'This column has a value getter and is not sortable.',
    align: "center",
    width: 140,
    valueGetter: (value, row) => (row.payPrice == 0 ? "消费券支付" : PAY_METHOD_MAP[value]),
  },
  {
    field: "user",
    headerName: "用户",
    // description: 'This column has a value getter and is not sortable.',
    width: 160,
    renderCell: ({row}) => {
      if (!row.merchant) return null;
      return <UserInfo uid={row.user.uid} avatar={row.user.avatar} nickname={row.user.nickname} enablePreview={false}/>;
    },
  },
  // {
  //   field: "version",
  //   headerName: "版本",
  //   // description: 'This column has a value getter and is not sortable.',
  //   // width: 160,
  //   valueGetter: (value, row) => `${value}.0`,
  // },
  {
    field: "createdAt",
    headerName: "创建时间",
    // description: 'This column has a value getter and is not sortable.',
    width: 200,
    valueGetter: (value, row) => moment(value).format("YYYY-MM-DD HH:mm"),
  },
];

const pointColumns = [
  {field: "id", headerName: "ID", width: 90},
  {
    field: "category",
    headerName: "类别",
    width: 200,
    valueGetter: (value, row) => POINT_CATEGORY_MAP[value],
  },
  {
    field: "amount",
    headerName: "数额",
    // type: "number",
    // width: 150,
  },
  {
    field: "current",
    headerName: "当前剩余",
    // type: "number",
    // width: 110,
    sortable: false,
  },
  {
    field: "type",
    headerName: "类型",
    // description: 'This column has a value getter and is not sortable.',
    // width: 160,
    valueGetter: (value, row) => POINT_RECORD_TYPE_MAP[value],
  },
  {
    field: "detail",
    headerName: "详情",
    // description: 'This column has a value getter and is not sortable.',
    width: 200,
    // valueGetter: (value, row) => `${parseFloat(Math.round((value / row.totalPrice) * 100))}%`,
  },
  {
    field: "relation",
    headerName: "关联订单",
    // description: 'This column has a value getter and is not sortable.',
    width: 200,
    // valueGetter: (value, row) => `${parseFloat(Math.round((value / row.totalPrice) * 100))}%`,
  },
  {
    field: "createdAt",
    headerName: "时间",
    // description: 'This column has a value getter and is not sortable.',
    width: 200,
    valueGetter: (value, row) => moment(value).format("YYYY-MM-DD HH:mm:ss"),
  },
];

const balanceColumns = [
  {field: "id", headerName: "ID", width: 90},
  // {
  //   field: "orderSN",
  //   headerName: "订单编号",
  //   width: 200,
  // },
  {
    field: "amount",
    headerName: "数额",
    // type: "number",
    // width: 150,
  },
  {
    field: "current",
    headerName: "当前剩余",
    // type: "number",
    // width: 110,
    sortable: false,
  },
  {
    field: "type",
    headerName: "类型",
    // description: 'This column has a value getter and is not sortable.',
    // width: 160,
    valueGetter: (value, row) => BALANCE_RECORD_TYPE_MAP[value],
  },
  {
    field: "detail",
    headerName: "详情",
    // description: 'This column has a value getter and is not sortable.',
    width: 200,
    // valueGetter: (value, row) => `${parseFloat(Math.round((value / row.totalPrice) * 100))}%`,
  },
  {
    field: "relation",
    headerName: "关联订单",
    // description: 'This column has a value getter and is not sortable.',
    width: 200,
    // valueGetter: (value, row) => `${parseFloat(Math.round((value / row.totalPrice) * 100))}%`,
  },
  {
    field: "createdAt",
    headerName: "时间",
    // description: 'This column has a value getter and is not sortable.',
    width: 200,
    valueGetter: (value, row) => moment(value).format("YYYY-MM-DD HH:mm:ss"),
  },
];

const parentColumns = [
  {
    field: "parent",
    headerName: "当前推荐人",
    // description: 'This column has a value getter and is not sortable.',
    width: 220,
    renderCell: ({row}) => {
      return <UserInfo {...(row.parent || {})} enablePreview={false}/>;
    },
  },
  {
    field: "prevParent",
    headerName: "之前推荐人",
    // description: 'This column has a value getter and is not sortable.',
    width: 220,
    renderCell: ({row}) => {
      return row.prevParent ? <UserInfo {...(row.prevParent || {})} enablePreview={false}/> : null;
    },
  },
  {
    field: "operator",
    headerName: "操作人",
    // description: 'This column has a value getter and is not sortable.',
    width: 120,
  },
  {
    field: "createdAt",
    headerName: "操作时间",
    // description: 'This column has a value getter and is not sortable.',
    width: 200,
    valueGetter: (value, row) => moment(value).format("YYYY-MM-DD HH:mm:ss"),
  },
];

export default function MerchantInfoDrawer({open, name, logo, mobile, mid, onClose}) {
  const areaMap = useSelector((state) => state.globalData.areaMap) || {};
  const [value, setValue] = useState(0);

  const [totalCommission, setTotalCommission] = useState(0);
  const [info, setInfo] = useState({});
  const [merchantStats, setMerchantStats] = useState({});
  const [orders, setOrders] = useState([]);
  const [pointRecords, setPointRecords] = useState([]);
  const [balanceRecords, setBalanceRecords] = useState([]);
  const [parentRecords, setParentRecords] = useState([]);

  useEffect(() => {
    getAreas();
  }, []);

  const handleChange = (event, newValue) => {
    switch (newValue) {
      case 1:
        getOrders();
        break;
      case 2:
        getPointRecords();
        break;
      case 3:
        getBalanceRecords();
        break;
      case 4:
        getMerchantStats();
        break;
      case 5:
        getParentRecords();
        break;
    }
    setValue(newValue);
  };

  useEffect(() => {
    if (!mid || !open) return;
    getMerchantInfo();
    getTotalCommission();
  }, [mid, open]);

  async function getTotalCommission() {
    const {data} = await asyncRequest({
      method: "get",
      path: `/merchant/commission/${mid}`,
    });

    setTotalCommission(data);
  }

  async function getMerchantInfo() {
    const {data} = await asyncRequest({
      method: "get",
      path: `/merchant/detail/${mid}`,
    });

    setInfo(data);
  }

  async function getOrders() {
    const {data} = await asyncRequest({
      path: "/payment/list",
      data: {
        mid,
        status: PAYMENT_STATUS.PAYED,
        page: 0,
        size: 100,
      },
    });

    setOrders(data);
  }

  async function getPointRecords() {
    const {data} = await asyncRequest({
      path: "/point/record/list",
      data: {
        uid: mid,
        isMer: true,
        page: 0,
        size: 2000,
      },
    });

    setPointRecords(data);
  }

  async function getBalanceRecords() {
    const {data} = await asyncRequest({
      path: "/finance/balance/list",
      data: {
        uid: mid,
        isMer: true,
        page: 0,
        size: 2000,
      },
    });

    setBalanceRecords(data);
  }

  async function getParentRecords() {
    const {data} = await asyncRequest({
      path: "/merchant/parent/record/list",
      data: {
        mid,
      },
    });

    setParentRecords(data);
  }

  async function getMerchantStats() {
    const {data} = await asyncRequest({
      path: "/merchant/stats/daily",
      data: {
        mid,
      },
    });

    setMerchantStats(data);
  }

  return (
    <>
      {open && (
        <Drawer
          anchor="right"
          open
          onClose={() => {
            // setShow(false);
            onClose();
          }}
          sx={{
            zIndex: 9000,
          }}
        >
          <Box sx={{width: "90vw"}} p={2}>
            <Stack alignContent="space-between" direction="row">
              <Stack
                alignSelf={1}
                sx={{
                  width: "100%",
                }}
              >
                <MerchantInfo enablePreview={false} mid={mid} logo={logo} name={name}/>
              </Stack>

              <IconButton onClick={onClose}>
                <CloseOutlined/>
              </IconButton>
            </Stack>
            <Grid container mt={3}>
              <Grid item xs>
                <Stack gap={1} alignItems="center">
                  <Typography>总让利额</Typography>
                  <Typography>{totalCommission || 0}</Typography>
                </Stack>
              </Grid>
              <Grid item xs>
                <Stack gap={1} alignItems="center">
                  <Typography>消费券</Typography>
                  <Typography>{info.xfqV2 || 0}</Typography>
                </Stack>
              </Grid>
              <Grid item xs>
                <Stack gap={1} alignItems="center">
                  <Typography>绿色积分</Typography>
                  <Typography>{info.pointsV2 || 0}</Typography>
                </Stack>
              </Grid>
              <Grid item xs>
                <Stack gap={1} alignItems="center">
                  <Typography>锁仓积分</Typography>
                  <Typography>{info.pointsV2Lock || 0}</Typography>
                </Stack>
              </Grid>
              {/* <Grid item xs>
                <Stack gap={1} alignItems="center">
                  <Typography>总订单数</Typography>
                  <Typography>{info.payedOrders || 0}</Typography>
                </Stack>
              </Grid> */}
              {/* <Grid item xs>
                <Stack gap={1} alignItems="center">
                  <Typography>总消费额</Typography>
                  <Typography>{info.totalPayed || 0}</Typography>
                </Stack>
              </Grid> */}
              {/* <Grid item xs>
                <Stack gap={1} alignItems="center">
                  <Typography>累计获得消费券</Typography>
                  <Typography>{info.totalReleased || 0}</Typography>
                </Stack>
              </Grid> */}
            </Grid>

            <Box sx={{width: "100%"}}>
              <Box sx={{borderBottom: 1, borderColor: "divider"}}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                  <Tab label="商户信息"/>
                  <Tab label="消费记录"/>
                  <Tab label="积分明细"/>
                  <Tab label="消费券明细"/>
                  <Tab label="业绩统计"/>
                  <Tab label="推荐人变更记录"/>
                </Tabs>
              </Box>

              <Box sx={{height: 700, width: "100%"}}>
                {value == 0 && (
                  <Stack p={2}>
                    <SectionHeader title="基础信息"/>
                    <Grid container py={1} rowGap={1}>
                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{width: 80}}>商户ID：</Typography>
                          <Typography>{info.mid}</Typography>
                        </Stack>
                      </Grid>

                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{width: 80}}>商户名称：</Typography>
                          <Typography>{info.name}</Typography>
                        </Stack>
                      </Grid>

                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{width: 80}}>手机号码：</Typography>
                          <Typography>{info.mobile}</Typography>
                        </Stack>
                      </Grid>

                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{width: 80}}>汇付ID：</Typography>
                          <Typography>{info.hfUid}</Typography>
                        </Stack>
                      </Grid>
                    </Grid>

                    <SectionHeader title="商户概况" mt={2}/>
                    <Grid container py={1} rowGap={1}>
                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{width: 80}}>是否直营：</Typography>
                          <Typography>{info.isZhiyin ? "是" : "否"}</Typography>
                        </Stack>
                      </Grid>

                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{width: 80}}>让利比例：</Typography>
                          <Typography>{info.rangli}%</Typography>
                        </Stack>
                      </Grid>

                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{width: 80}}>商户状态：</Typography>
                          <Typography>{["停用", "正常"][info.status]}</Typography>
                        </Stack>
                      </Grid>

                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{width: 80}}>入驻时间：</Typography>
                          <Typography>{moment(info.createdAt).format("YYYY-MM-DD HH:mm:ss")}</Typography>
                        </Stack>
                      </Grid>
                      {/* 
                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{ width: 80 }}>版本：</Typography>
                          <Typography>{info.version}.0</Typography>
                        </Stack>
                      </Grid> */}

                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{width: 80}}>所属区域：</Typography>
                          <Typography>
                            {areaMap[info.provinceId]}
                            {areaMap[info.cityId]}
                            {areaMap[info.districtId]}
                          </Typography>
                        </Stack>
                      </Grid>
                    </Grid>

                    <SectionHeader title="推荐关系" mt={2}/>
                    <Grid container py={1} rowGap={1}>
                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{width: 80}}>管理员：</Typography>
                          {!!info.admin && <UserInfo {...info.admin.user} enablePreview={false}/>}
                        </Stack>
                      </Grid>

                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{width: 80}}>推荐人：</Typography>
                          {!!info.parent && <UserInfo {...info.parent} enablePreview={false}/>}
                        </Stack>
                      </Grid>

                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{width: 80}}>区代：</Typography>
                          {!!info.agent && <UserInfo {...info.agent} enablePreview={false}/>}
                        </Stack>
                      </Grid>
                    </Grid>
                  </Stack>
                )}
                {value == 1 && (
                  <DataGrid
                    rows={orders}
                    columns={orderColumns}
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 10,
                        },
                      },
                    }}
                    disableColumnFilter
                    disableColumnSorting
                    pageSizeOptions={[5]}
                    // checkboxSelection
                    disableRowSelectionOnClick
                  />
                )}

                {/* 积分明细 */}
                {value == 2 && (
                  <DataGrid
                    rows={pointRecords}
                    columns={pointColumns}
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 10,
                        },
                      },
                    }}
                    disableColumnFilter
                    disableColumnSorting
                    pageSizeOptions={[5]}
                    // checkboxSelection
                    disableRowSelectionOnClick
                  />
                )}

                {/* 余额明细 */}
                {value == 3 && (
                  <DataGrid
                    rows={balanceRecords}
                    columns={balanceColumns}
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 10,
                        },
                      },
                    }}
                    disableColumnFilter
                    disableColumnSorting
                    pageSizeOptions={[5]}
                    // checkboxSelection
                    disableRowSelectionOnClick
                  />
                )}

                {value == 4 && (
                  <Stack p={2}>
                    {/* <SectionHeader title="基础信息" /> */}
                    <Grid container py={1} rowGap={1}>
                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{width: 80}}>年度业绩：</Typography>
                          <Typography>{merchantStats.yearly || 0}</Typography>
                        </Stack>
                      </Grid>

                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{width: 80}}>上月业绩：</Typography>
                          <Typography>{merchantStats.lastMonthly || 0}</Typography>
                        </Stack>
                      </Grid>

                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{width: 80}}>本月业绩：</Typography>
                          <Typography>{merchantStats.monthly || 0}</Typography>
                        </Stack>
                      </Grid>

                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{width: 80}}>昨日业绩：</Typography>
                          <Typography>{merchantStats.yesterday || 0}</Typography>
                        </Stack>
                      </Grid>

                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{width: 80}}>今日业绩：</Typography>
                          <Typography>{merchantStats.today || 0}</Typography>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Stack>
                )}

                {/* 推荐人 */}
                {value == 5 && (
                  <DataGrid
                    rows={parentRecords}
                    columns={parentColumns}
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 10,
                        },
                      },
                    }}
                    disableColumnFilter
                    disableColumnSorting
                    pageSizeOptions={[5]}
                    // checkboxSelection
                    disableRowSelectionOnClick
                  />
                )}
              </Box>
            </Box>
          </Box>
        </Drawer>
      )}
    </>
  );
}
